import "@/App.css";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ExplordioPage } from "@/pages/ExplordioPage";
import { ContactPage } from "@/pages/ContactPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { TermsPage } from "@/pages/TermsPage";

function Home() {
  const [activeFeature, setActiveFeature] = useState(null);
  const [contactOpen, setContactOpen] = useState(false);
  const [libraryOpen, setLibraryOpen] = useState(false);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setActiveFeature(null);
        setContactOpen(false);
        setLibraryOpen(false);
      }
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, []);

  return (
    <>
      <ExplordioPage onFeatureOpen={setActiveFeature} onContactOpen={() => setContactOpen(true)} onLibraryOpen={() => setLibraryOpen(true)} />
      <AnimatePresence>
        {activeFeature ? (
          <ExplordioPage.FeatureModal
            feature={activeFeature}
            onClose={() => setActiveFeature(null)}
          />
        ) : null}
        {contactOpen ? (
          <ExplordioPage.ContactModal onClose={() => setContactOpen(false)} />
        ) : null}
        {libraryOpen ? (
          <ExplordioPage.MediaLibraryModal onClose={() => setLibraryOpen(false)} />
        ) : null}
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;